import { ChangeDetectionStrategy, Component } from '@angular/core';
import { OdooToast, OdooToastService } from 'src/app/services/odoo/odoo-toast.service';

@Component({
  selector: 'app-odoo-toast',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="odoo-toasts" aria-live="polite" role="status">
      <div class="odoo-toast" *ngFor="let t of toasts.lista$ | async; trackBy: porId" [class.odoo-toast-mal]="!t.ok">
        <i class="fas" [ngClass]="t.ok ? 'fa-check-circle' : 'fa-exclamation-circle'" aria-hidden="true"></i>
        <span>{{ t.texto }}</span>
        <button type="button" class="kb-btn kb-btn-ghost kb-btn-icon h-6 w-6" aria-label="Cerrar aviso" (click)="toasts.cerrar(t.id)">
          <i class="fas fa-times" aria-hidden="true"></i>
        </button>
      </div>
    </div>`,
  styles: [`
    .odoo-toasts { position: fixed; right: 1rem; bottom: 1rem; z-index: 1070; display: flex; flex-direction: column; gap: .5rem; max-width: min(24rem, calc(100vw - 2rem)); }
    .odoo-toast { display: flex; align-items: center; gap: .6rem; padding: .65rem .8rem; border-radius: .5rem; font-size: .875rem;
      border: 1px solid hsl(var(--border)); background: hsl(var(--popover)); color: hsl(var(--popover-foreground));
      box-shadow: 0 8px 24px -8px rgb(0 0 0 / .25); animation: odoo-toast-in 180ms cubic-bezier(.23,1,.32,1); }
    .odoo-toast > span { flex: 1; }
    .odoo-toast .fa-check-circle { color: hsl(var(--primary)); }
    .odoo-toast-mal { border-color: hsl(var(--destructive) / .5); }
    .odoo-toast-mal .fa-exclamation-circle { color: hsl(var(--destructive)); }
    @keyframes odoo-toast-in { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: none; } }
    @media (prefers-reduced-motion: reduce) { .odoo-toast { animation: none; } }
  `],
})
export class OdooToastComponent {
  constructor(public toasts: OdooToastService) {}
  porId = (_: number, t: OdooToast): number => t.id;
}
